import { DfcInviteeResponse } from 'api';
import { AllDialectOptions } from 'types/dialects';
import { isExclusivePronoun } from 'domain/pronouns';
import { notEnglish } from './languageUtils';

export const disabledDfcLearnerPronounProfile = (
  learner: DfcInviteeResponse,
  selectedDialect: AllDialectOptions,
): boolean =>
  !isExclusivePronoun(learner.pronoun) && notEnglish(selectedDialect);
